<div class="first-row">
    <div class="league-details">
        <span class="icon sports-{{ upsellEvent.event?.sport?.id }}"></span>
        <span class="league-name">{{ upsellEvent.event.league?.name }}</span>
    </div>
    <ms-event-timer [live]="upsellEvent.event.live" [start]="upsellEvent.event.startDate" [scoreboard]="upsellEvent.event.scoreboard" />
</div>
<div class="second-row" [ngClass]="{ 'with-participant': showParticipantImage }">
    <ms-participant-image
        *ngIf="showParticipantImage"
        [participantImage]="upsellEvent.eventParticipant?.image"
        [sportId]="upsellEvent.event.sport?.id"
        [showFallback]="false"
        (logoLoaded)="logoLoaded($event)" />
    <div class="upsell-event-details">
        <div class="team-details-with-odd">
            <div class="team-detail-event-name">
                <span class="team-detail">{{ upsellEvent.winningMarket }}</span>
                <span class="event-name">{{ upsellEvent.event.name }}</span>
            </div>
            <ms-event-pick
                [option]="upsellEvent.bestSellingOption"
                [event]="upsellEvent.event"
                [optionGroup]="upsellEvent.bestSellingOptionGroup"
                [trackingSource]="trackingSource"
                [trackingPosition]="upsellIndex"
                [sourceOfPick]="sourceOfPick">
                <i
                    class="theme-locked-i"
                    *ngIf="!(upsellEvent.bestSellingOptionGroup?.online && upsellEvent.bestSellingOption?.online); else optionView"></i>
                <ng-template #optionView>
                    <div class="result-odds option-value">
                        <ms-font-resizer
                            [defaultSize]="1"
                            [maxChars]="6"
                            [value]="upsellEvent.bestSellingOption?.nativePrice | msNativePriceFormatter" />
                    </div>
                </ng-template>
            </ms-event-pick>
        </div>
        <bs-upsell-winnings [event]="upsellEvent" />
    </div>
</div>
